import LoadingButton from '@mui/lab/LoadingButton';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import Box from '@mui/system/Box';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';

import { ContactAssessmentFormProps } from '~organisations/domain';

const ContactAssessmentForm = ({ formSubmitting, onClose, onSubmit }: ContactAssessmentFormProps) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      records_updated: false,
      professionalism: false,
      escalation_proccess: false,
      summary: '',
    },
  });

  const onSubmitFn = handleSubmit((data: { [key: string]: any }) => {
    onSubmit(data);
  });

  return (
    <form onSubmit={onSubmitFn} noValidate>
      <Controller
        name='records_updated'
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={<Checkbox {...field} id='records_updated' disabled={formSubmitting} checked={field.value} />}
            label='Did the team member update account records?'
          />
        )}
      />

      <Controller
        name='professionalism'
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={<Checkbox {...field} id='professionalism' disabled={formSubmitting} checked={field.value} />}
            label='Did the team member conduct themselves professionally?'
          />
        )}
      />

      <Controller
        name='escalation_proccess'
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={<Checkbox {...field} id='escalation_proccess' disabled={formSubmitting} checked={field.value} />}
            label='Did team member adhere to the escalation proccess?'
          />
        )}
      />

      <Controller
        name='summary'
        control={control}
        rules={{ required: 'A summary is Required' }}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            multiline
            rows={4}
            margin='normal'
            variant='outlined'
            id='summary'
            label='Summary'
            disabled={formSubmitting}
            error={Boolean(errors.summary)}
            helperText={errors.summary?.message}
          />
        )}
      />

      <Box sx={{ textAlign: 'right' }}>
        <Button disabled={formSubmitting} onClick={onClose}>
          Cancel
        </Button>

        <LoadingButton
          sx={{ marginLeft: 1 }}
          type='submit'
          variant='contained'
          disableElevation
          loading={formSubmitting}
          color='primary'>
          Update
        </LoadingButton>
      </Box>
    </form>
  );
};

export default ContactAssessmentForm;
